/**
 * Asset Management category for homes used by rental leases / ledger.
 * Must match server `INVESTMENT_HOME_CATEGORY` in server/utils/rentalInvestmentHomeAsset.js.
 */
export const INVESTMENT_HOME_ASSET_CATEGORY = "Investment Home";
